/**
 * @GpsConfig.vue
 * @Description GPS标签配置
 * @Author CC
 * @Date 2025/09/20
 **/
/* HTML */
<template>
	<div class="view-tree-table">
		<!-- router-title-box start -->
		<div class="router-title-box">
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">
					<span style="position: absolute;">&gt;&ensp;设备管理&ensp;&gt;&ensp;GPS设备</span>
					<el-tabs class="whole-page-tabs" v-model="activeName" @tab-click="handleClick" tab-position="top">
						<el-tab-pane label="GPS标签配置" name="first" clor="red"></el-tab-pane>
						<el-tab-pane label="流量卡管理" name="second"></el-tab-pane>
						<el-tab-pane v-if="false" label="消息管理" name="third"></el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<!-- router-title-box end -->

		<GpsTagTable v-show="activeName == 'first'" ref="gpsTagTable" :accountManagerInfos="accountManagerInfos" @switchTab="switchTab" />
		<GpsTagSimTable v-show="activeName == 'second'" ref="gpsTagSimTable" :accountManagerInfos="accountManagerInfos" />
		<GpsTagNoticeTable v-if="false" v-show="activeName == 'third'" ref="gpsTagNoticeTable" :accountManagerInfos="accountManagerInfos" />

	</div>
</template>

/* JS */
<script>
	// API 账户
	import ApiAccount from '@/request/api-account';
	import GpsTagTable from '@/components_outdoor/Device/GpsTagTable';
	import GpsTagSimTable from '@/components_outdoor/Device/GpsTagSimTable';
	import GpsTagNoticeTable from '@/components_outdoor/Device/GpsTagNoticeTable';
	import GlobalFun from '@/global/global-function';

	export default {
		/**
		 * 组件名
		 */
		name: "GpsTagConfig",
		/**
		 * 组件引用
		 */
		components: {
			GpsTagTable,
			GpsTagSimTable,
			GpsTagNoticeTable
		},
		/**
		 * 数据定义
		 */
		data() {
			return {
				// mini max tree box
				activeName: 'first',
				// 所有管理员账户
				accountManagerInfos: {},
				// route params
				routeParams: {},
			}
		}, // data
		created() {
			// 查询所有管理员账户
			this.searchAccountManager();
		}, // created
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			this.routeParams = Object.assign({}, this.$route.params);
			this.activeName = this.routeParams.tab == 'sim' ? 'second' : 'first';
		},// mounted
		/**
		 * 方法定义
		 */
		methods: {
			/**
			 * @Des 关闭路由
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			closeRouter() {
				// 跳转到 首页
				this.$router.replace({
					path: this.$store.state.homePage
				}, () => {}, () => {});
			}, // closeRouter

			/**
			 * @Description 点击事件
			 * @Date 2025/09/20
			 * @Param
			 * @Return
			 */
			handleClick(tab, event) {
				if(tab.index == 0) {
					this.activeName = 'first';
					this.$refs.gpsTagTable.searchGpsTag();
				} else if(tab.index == 1) {
					this.activeName = 'second';
					this.$refs.gpsTagSimTable.searchGpsTag();
				} else {
					this.activeName = 'third';
					this.$refs.gpsTagNoticeTable.searchNotice();
				}
			},

			switchTab(index, option, keyword) {
				if(index == 0) {
					this.activeName = 'first';
				} else if(index == 1) {
					this.activeName = 'second';
					if(option == GlobalFun.OptType.SEARCH) {
						this.$refs.gpsTagSimTable.searchKeyword(keyword);
					}
				} else if(index == 2) {
					this.activeName = 'third';
					this.$refs.gpsTagNoticeTable.searchNotice();
				}
			},

			/**
			 * @Description
			 * @Param 查询所有管理员账户
			 * @Auth CC
			 * @Date 2025/09/20
			 */
			searchAccountManager() {
				if (this.$store.getters.getUserRoleId != '1') return false;
				this.$request.postJsonRequest(ApiAccount.searchAccountManagerApi, {}).then(result => {
					this.accountManagerInfos = Object.assign({}, {});
					if(result.code == 0) {
						result.data.forEach((row, index) => {
							let key = row.key;
							this.accountManagerInfos[key] = row;
						})
					}
				}).catch(error => {
					console.log("查询所有管理员账户异常：" + this.$request.error.msg);
				})
			}, // searchAccountManager

		},
	}
</script>

/* CSS */
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/system-outdoor/device/gpsTagConfig.vue